import type { Member } from '~/common/types';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

export async function updateProjectMemberNotifications(
  projectId: string,
  updates: Partial<Member['notifications']>,
): Promise<Member> {
  const { data } = await axios({
    method: 'PUT',
    url: `/v1/preferences/projects/${projectId}/members/notifications`,
    data: { updates },
  });

  return data;
}
